

const isLocalhost = ['localhost', '127.0.0.1'].includes(window.location.hostname)
const defaultCommercialWebURL = isLocalhost
    ? 'http://localhost:3000'
    : window.location.hostname.startsWith('preview-')
        ? 'https://preview.worksplaniq.com'
        : 'https://worksplaniq.com'

const Constant = {
    brandName: 'WorksPlanIQ Application',
    version: '0.1.0',
    baseApiURL: window.config?.apiUrl || process.env.REACT_APP_API_URL,
    commercialWebURL:
        window.config?.commercialWebUrl ||
        process.env.REACT_APP_WEB_URL ||
        defaultCommercialWebURL,
    useCaptchaValidationLogin: window.config?.useCaptchaValidationLogin ?? false,
    useCaptchaValidationForgotPassword:
        window.config?.useCaptchaValidationForgotPassword ?? false,
    useCaptchaValidationResetPassword:
        window.config?.useCaptchaValidationResetPassword ?? false,
    lengthCaptcha: 6,

    mediaQuery: {
        isMobile: '(max-width: 576px)',
        isTab: '(max-width: 768px)',
        isLG: '(max-width: 992px)',
    },

    keyConfigDb: {
        PR_Attachment_Allowed_Extension: "PR_Attachment_Allowed_Extension",
        PR_Attachment_File_Path: "PR_Attachment_File_Path",
        PR_Attachment_Max_Size: "PR_Attachment_Max_Size",
        Goods_Percentage_VAT: "Goods_Percentage_VAT",
        Service_Percentage_VAT: "Service_Percentage_VAT",


        Employee_Portrait_Allowed_Extension: "Employee_Portrait_Allowed_Extension",
        Employee_Portrait_Max_Size: "Employee_Portrait_Max_Size",
        Employee_Portrait_Width: "Employee_Portrait_Width",
        Employee_Portrait_Height: "Employee_Portrait_Height",
    },

    message: {
        loading: "Loading...",
        downloading: "Downloading...",
        savingData: "Saving Data...",
        success: "Success!",
        fail: "Failed!",
        saveDataSuccess: "Data saved successfully.",
        submitDataSuccess: "Data submitted successfully.",
        approveDataSuccess: "Data approved successfully.",
        reviseDataSuccess: "Data revised successfully.",
        saveDataFail: "Saving data failed.",
        deleteDataSuccess: "Delete success.",
        deleteDataFail: "Delete failed.",
        delete: "Delete",
        cancel: "Cancel",
        onLogout: "Logging out...",
        logoutSuccess: "You have been logged out successfully",
        errorForm: "Please complete the form.",
        filterMoreThan1Month: "Searching for more than 1 month can take a long time. Are you sure you want to continue?",
        notAuthorizedDesc: "You do not have the necessary permissions to access this resource",
        notAuthorized: "Not Authorized!",
        itemAddSuccess: "Item added successfully.",
        vendorAddSuccess: "Vendor added successfully.",
        successSendEmail: "Success Send Email.",
    },
    placeholder: {
        keyword: "keyword...",
        enterCode: "Enter code",
        enterName: "Enter name",
        enterFirstName: "Enter First Name",
        enterEmail: "Enter email",
        enterAddress: "Enter Address",
        enterContactNo: "Enter Contact Number",
        enterContactPerson: "Enter Contact Person",
        enterDepartmentName: "Enter department name",
        enterCostCenterName: "Enter cost center name",
        enterGoodsCode: "Enter goods code",
        enterGoodsName: "Enter goods name",
        enterServiceCode: "Enter goods code",
        enterServiceName: "Enter goods name",
        enterItemCategoryGoodsCode: "Enter item category goods code",
        enterItemCategoryGoodsName: "Enter item category goods name",
        enterItemCategoryServiceName: "Enter item category service name",
        enterSubject: "Enter subject",
        enterItemName: "Enter item name",
        enterItemCode: "Enter item code",
        enterItemTypeName: "Enter item type", /* add filter item type, update by Try, 13 Oktober 2023  */

    },
    buttonText: {
        "backToHome": "Back to Home"
    },
    modalWidth: {
        sm: "300px",
        md: "500px",
        lg: "800px",
        xl: "1140px",
    },
    modalWidthInt: {
        sm: 300,
        md: 500,
        lg: 800,
        xl: 1140,
    },
    datePickerFormat: "DD MMM YYYY",
    dateFormatWithTime: "DD MMM YYYY HH:mm:ss",
    dateFormatWithTimeWoSecond: "DD MMM YYYY HH:mm",
    stateDateFormat: "YYYY-MM-DD",
    PRDocumentStatus: {
        Draft: 1,
        NeedApproval: 3,
        Approved: 4,
        NeedReviseString: "Need Revise",
        NeedRevision: 10
    },
    RFQDocumentStatus: {
        Draft: 1,
        NeedApproval: 3,
        Approved: 4,
        NeedReviseString: "Need Revise",
        NeedRevision: 11
    },
    VSDocumentStatus: {
        Draft: 1,
        NeedApproval: 3,
        Approved: 4,
        NeedReviseString: "Need Revise",
        NeedRevision: 4
    },
    PODocumentStatus: {
        Draft: 1,
        NeedApproval: 3,
        Approved: 4,
        NeedReviseString: "Need Revise",
        NeedRevision: 10
    },
    ROGSDocumentStatus: {
        Draft: 1,
        NeedApproval: 3,
        Approved: 5,
        NeedReviseString: "Need Revise",
        NeedRevision: 4
    },
    IVCRDocumentStatus: {
        Draft: 1,
        NeedApproval: 3,
        Approved: 4,
        NeedReviseString: "Need Revise",
        NeedRevision: 9
    },
    delayFilter: 1000,
    typeItemPR: {
        GOODS: 1,
        SERVICES: 2
    },
    typeItemRFQ: {
        GOODS: 1,
        SERVICES: 2
    },
    RFQType: {
        Tender: 1,
        DirectAppointment: 2
    },
    typeAttachmentFormRFQ: {
        INTERNAL: 1,
        VENDOR: 2,
    },
    PRType: {
        CATALOG: 1,
        NONCATALOG: 2,
    },
    ItemType: {
        GOODS: 1,
        SERVICES: 2
    },
    PaymentType: {
        CASH: 1,
        BANK_TRANSFER: 2
    },
    ConstantQueryStringTab: {
        list: 'list',
        pendingTask: 'pending-task'
    },
    ConstantParamTab: 'tabActive',
    WfDocTypeId: {
        PR: 1,
        RFQ: 2,
        VS: 4,
        PO: 5,
        ROGS: 6,
        Invoice: 7,
    },
    WfApprovalSettingTypeId: {
        FinalApprove: 1,
        Superior: 2,
        WorkflowRole: 3,
        CostCenter: 4,
    },
    DashboardPendingTaskModule: {
        PR: "PR",
        RFQ: "RFQ",
        VS: "VS",
        PO: "PO",
        ROGS: "ROGS",
        Invoice: "Invoice",
    },
    MenuIconString: {
        PR: "PR",
        RFQ: "RFQ",
        VQ: "VQ",
        VS: "VS",
        PO: "PO",
        ROGS: "ROGS",
        Invoice: "Invoice",
        Master: "Master",
        Report: "Report",
        Dashboard: "Dashboard",
    },
    typeChartDashboardSummary: {
        count: 1,
        amount: 2
    },
    typeProgressStatusDashboardSummary: {
        completed: "Completed",
        paid: "Paid",
        inprogress: "In Progress",
        closed: "Closed",
        late: "Late"
    },
    typeChartDashboardAmountMonthly: {
        po: "PO",
        invoice: "Invoice"
    },
    fileImageExtenstion: ['jpg', 'jpeg', 'png'],
}

export default Constant
